import { render, staticRenderFns } from "./LinkSelect.vue?vue&type=template&id=83d6367c&"
import script from "./LinkSelect.vue?vue&type=script&lang=js&"
export * from "./LinkSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports